import React from 'react';
import FormViewModal from 'components/common/Modals/FormViewModal';
import RestockingChargeSchema from './RestockingChargeDialog.form';
import { IRestockingChargeDialogProperties } from './RestockingChargeDialog.properties';
import { useCNContextSelector } from '../CreditNotes.context';
import { useRestockingChargeDialogCalculate } from 'api/creditNotes/creditNotes';

const RestockingChargeDialog = (props: IRestockingChargeDialogProperties): JSX.Element => {

  const { open, loading = false, data, onCancel, onOk, values } = props;

  const formSchema = RestockingChargeSchema.RestockingCharge;
  const CreditNoteId = useCNContextSelector<'CreditNote'>((state) => state.CreditNote);
  const [initialValues, setInitialValues] = React.useState(data?.inlineObject?.RestockingCharge);
  const [valuesSchema, setValuesSchema] = React.useState(data?.schema?.RestockingCharge);

  const calculateRestockingChargeMuatation = useRestockingChargeDialogCalculate();

  const calculateRestockingCharge = (value: any) => {
    calculateRestockingChargeMuatation.mutateAsync({
      WorkCreditNoteId: CreditNoteId,
      ...values,
      RestockingFee: value
    }).then((response) => {
      if (response && response?.Status && response?.RestockingCharge) {
        setInitialValues(response?.RestockingCharge?.inlineObject);
        setValuesSchema(response?.RestockingCharge?.schema);
      }
    });
  };

  const getActions = () => {
    return [
      {
        title: 'Ok',
        iconName: 'CheckCircle',
        listener: async () => {
          if (onOk) {
            onOk(values);
          }
        }
      },
      {
        title: 'Cancel',
        isDefault: true,
        iconName: 'Cancel',
        listener: () => {
          if (onCancel) {
            onCancel();
          }
        },
      },
    ];
  };

  return (
    <div>
      <FormViewModal
        open={open}
        loading={loading}
        title='Restocking Charge'
        dialogStyles={{
          width: 600,
          minHeight: 550,
          maxHeight: 550,
          height: '100%'
        }}
        formProps={{
          formSchema: formSchema,
          initialValues: initialValues,
          valuesSchema: valuesSchema,
          fieldExtensions: {
            RestockingFee: {
              creditNoteId: CreditNoteId,
              creditAmount: initialValues?.CreditAmount,
              onValueChanged: calculateRestockingCharge
            },
          }
        }}
        actions={getActions()}
        dialogActionsButtons={true}
        dialogActionsShadow={false}
      />
    </div>
  );
};

export default RestockingChargeDialog;
